import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
};

// Get all students
export const getStudents = async () => {
    const response = await axios.get(`${API_URL}/students`, getAuthHeaders());
    return response.data;
};

// Get student by ID
export const getStudent = async (studentId) => {
    const response = await axios.get(`${API_URL}/students/${studentId}`, getAuthHeaders());
    return response.data;
};

// Create a new student
export const createStudent = async (studentData) => {
    const response = await axios.post(`${API_URL}/students`, studentData, getAuthHeaders());
    return response.data;
};

// Update student
export const updateStudent = async (studentId, studentData) => {
    const response = await axios.put(`${API_URL}/students/${studentId}`, studentData, getAuthHeaders());
    return response.data;
};

// Delete student
export const deleteStudent = async (studentId) => {
    const response = await axios.delete(`${API_URL}/students/${studentId}`, getAuthHeaders());
    return response.data;
};

// Get all classes for a specific student
export const getStudentClasses = async (studentId) => {
    const response = await axios.get(`${API_URL}/students/${studentId}/classes`, getAuthHeaders());
    return response.data;
};

// Get enrollments for a specific student within a date range
export const getStudentEnrollments = async (studentId, startDate, endDate) => {
    const response = await axios.get(
        `${API_URL}/students/${studentId}/enrollments`,
        {
            ...getAuthHeaders(),
            params: {
                start: startDate,
                end: endDate
            }
        }
    );
    return response.data;
};

// Get class events for a specific student on a specific date
export const getStudentClassEvents = async (studentId, eventDate) => {
    const response = await axios.get(
        `${API_URL}/students/${studentId}/class_events`,
        {
            ...getAuthHeaders(),
            params: {
                event_date: eventDate
            }
        }
    );
    return response.data;
};

// Get all attendance records for a specific student
export const getStudentAttendance = async (studentId) => {
    const response = await axios.get(`${API_URL}/students/${studentId}/attendance`, getAuthHeaders());
    return response.data;
};

// Get detailed attendance with classes and events for a specific student
export const getStudentDetailedAttendance = async (studentId) => {
    const response = await axios.get(`${API_URL}/students/${studentId}/detailed-attendance`, getAuthHeaders());
    return response.data;
};

// Create a note for a student
export const createStudentNote = async (studentId, noteData) => {
    const response = await axios.post(`${API_URL}/students/${studentId}/notes`, noteData, getAuthHeaders());
    return response.data;
};

// Get notes for a student
export const getStudentNotes = async (studentId) => {
    const response = await axios.get(`${API_URL}/students/${studentId}/notes`, getAuthHeaders());
    return response.data;
};

const studentService = {
    getStudents,
    getStudent,
    createStudent,
    updateStudent,
    deleteStudent,
    getStudentClasses,
    getStudentEnrollments,
    getStudentClassEvents,
    getStudentAttendance,
    getStudentDetailedAttendance,
    createStudentNote,
    getStudentNotes
};

export default studentService;
